import { google, outlook, office365, yahoo, ics } from 'calendar-link';

export default class CalLinks {

	constructor(element) {
		this.element = element;
		if (!(this.element instanceof HTMLElement)) {
			throw new Error('Could not construct calendar links: No element found.');
		}
		if (!this.element.dataset.startDatetime || !this.element.dataset.endDatetime || !this.element.dataset.title) {
			throw new Error('Could not construct calendar links: start datetime, end datetime, and title are required.');
		}
		this.googleLink= this.element.querySelector('.gigs-cal-links__link--google');
		this.outlookLink= this.element.querySelector('.gigs-cal-links__link--outlook');
		this.office365Link= this.element.querySelector('.gigs-cal-links__link--office365');
		this.yahooLink= this.element.querySelector('.gigs-cal-links__link--yahoo');
		this.icsLink= this.element.querySelector('.gigs-cal-links__link--ics');
		this.eventData = {
			uid: this.element.dataset.uid,
			start: this.element.dataset.startDatetime,
			end: this.element.dataset.endDatetime,
			title: this.element.dataset.title,
			description: this.element.dataset.description,
			location: this.element.dataset.location,
		};
		this.eventURLs = {
			google: google(this.eventData),
			outlook: outlook(this.eventData),
			office365: office365(this.eventData),
			yahoo: yahoo(this.eventData),
			ics: ics(this.eventData),
		};
	}

	init() {
		if (this.googleLink instanceof HTMLAnchorElement) {
			this.googleLink.href = this.eventURLs.google;
		}
		if (this.outlookLink instanceof HTMLAnchorElement) {
			this.outlookLink.href = this.eventURLs.outlook;
		}
		if (this.office365Link instanceof HTMLAnchorElement) {
			this.office365Link.href = this.eventURLs.office365;
		}
		if (this.yahooLink instanceof HTMLAnchorElement) {
			this.yahooLink.href = this.eventURLs.yahoo;
		}
		if (this.icsLink instanceof HTMLAnchorElement) {
			this.icsLink.href = this.eventURLs.ics;
		}
	}
}
